import api from '../api'

// Types
import { User } from './types'

export const authenticate = async () => {
  try {
    return await api.get('/user/authenticate')
  } catch(err) {
    return null
  }
}

export const login = async (username: string, password: string) => {
  try {
    return await api.post('/user/login', { username, password })
  } catch(err) {
    return null
  }
}

export const logout = async () => {
  try {
    return await api.get('/user/logout')
  } catch(err) {
    return null
  }
}

export const signup = async (user: User) => {
  // try {
    return await api.post('/user/signup', { ...user })
  // } catch(err) {
  //   return null
  // }
}
